import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.scss';
import _ from 'lodash';
import _get from 'lodash/get';

import RequestEventRessonPopUp from 'containers/RequestEventRessonPopUp';
import StudentFirstJoinEventProfileForm from 'components/StudentFirstJoinEventProfileForm';
import CancelRequestEventPopUp from 'containers/CancelRequestEventPopUp';
import PopupLockEvent from 'containers/PopupLockEvent';

//Component
import Banner from './Banner';
import MapDetail from './MapDetail';
import RequestedUserList from './RequestedUserList';
import EventInfo from './EventInfo';
import JoinedUserList from './JoinedUserList';

class EventDetail extends Component {
  constructor(props) {
    super(props);
    this.banner = React.createRef();
    this.state = {
      currentHeight: 0,
      bannerHeight: 0,
      bannerWidth: 0,
      contentPaddingHeight: 0,
      collapse: false
    };
  }
  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }
  componentDidUpdate(prevProps, prevState) {
    const newState = {};
    if (this.banner.current.clientHeight > prevState.bannerHeight) {
      newState.bannerHeight = this.banner.current.clientHeight;
    }
    if (this.banner.current.clientHeight !== prevState.currentHeight) {
      newState.currentHeight = this.banner.current.clientHeight;
    }
    if (this.state.bannerHeight > prevState.bannerHeight) {
      newState.contentPaddingHeight = this.state.bannerHeight;
    }
    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  }
  handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > this.state.bannerHeight - currentScrollY) {
      if (this.state.collapse === false) {
        this.setState({ collapse: true });
      }
    } else {
      if (this.state.collapse === true) {
        this.setState({ collapse: false });
      }
    }
  }

  render() {
    const { eventInfo, stateInfo, openPopupChooseStudent, openPopupViewStudentProfile } = this.props;
    const { collapse } = this.state;
    const eventImage = eventInfo && eventInfo.image && eventInfo.image.thumbLarge ? eventInfo.image.thumbLarge : '/images/default-event.svg';

    return (
      <div id="event-details">
        {/* Banner Section */}
        <div ref={this.banner} className="fixed-header-container">
          <Banner stateInfo={stateInfo} collapse={collapse} eventInfo={eventInfo} />
        </div>
        <div className="event-details-container" style={{ paddingTop: this.state.contentPaddingHeight + 'px', minHeight: '100vh' }}>
          <div className="event-details-content">
            <div className="row thumbnail-map">
              {/* Event Detail Section */}
              <div className="col-md-7 col-sm-12">
                <div className="event-image-container">
                  <div className="graduate-title">
                    {eventInfo && eventInfo.graduateYear && eventInfo.graduateYear.name}
                  </div>

                  <div className="event-thumbnail">
                    <div style={{backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.1), rgb(0, 0, 0), rgba(0, 0, 0, 0.1)), url("${eventImage}")`}}/>
                    <img
                      src={eventImage}
                      alt="社長メシ"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-sm-12">
                {/* Map Section */}
                { eventInfo && eventInfo.offerEvent === false && <MapDetail currentHeight={this.state.currentHeight} eventInfo={eventInfo} stateInfo={stateInfo}/> }
              </div>
            </div>
            {/* Requested User List Section */}
            <div className="row">
              <div className="col-md-7 col-sm-12 col-xs-12">
                <RequestedUserList
                  requestedUsers={eventInfo.requestedUsers}
                  openPopupChooseStudent={openPopupChooseStudent}
                  openPopupViewStudentProfile={openPopupViewStudentProfile}
                  eventId={eventInfo.objectId}
                  isOfferEvent={_get(eventInfo, 'offerEvent', false)}
                />
              </div>
            </div>
            {/* Event Info Section */}
            <div className="row">
              <div className="col-md-7">
                <EventInfo eventInfo={{
                  capacity: eventInfo.capacity,
                  explanation: eventInfo.explanation,
                  newDescription: eventInfo.newDescription,
                  graduateYear: eventInfo.graduateYear && eventInfo.graduateYear.name,
                  prefecture: eventInfo.prefecture && eventInfo.prefecture.name,
                  offerEvent: eventInfo.offerEvent && eventInfo.offerEvent
                }} />
              </div>
            </div>
            {/* Joined User List Section */}
            <div className="row">
              <div className="col-md-7 col-sm-12 col-xs-12">
                <JoinedUserList
                  joinedUsers={eventInfo.joinedUsers}
                  eventId={eventInfo.objectId}
                  status="joined"
                  openPopupViewStudentProfile={openPopupViewStudentProfile}
                />
              </div>
            </div>
            {/* Denied User List Section */}
            <div className="row">
              <div className="col-md-7 col-sm-12 col-xs-12">
                <JoinedUserList
                  joinedUsers={eventInfo.deniedUsers}
                  eventId={eventInfo.objectId}
                  status="denied"
                  openPopupViewStudentProfile={openPopupViewStudentProfile}
                />
              </div>
            </div>
          </div>
        </div>
        <RequestEventRessonPopUp />
        <StudentFirstJoinEventProfileForm />
        <CancelRequestEventPopUp />
        <PopupLockEvent />
      </div>
    );
  }
}

EventDetail.propTypes = {
  eventInfo: PropTypes.object,
  stateInfo: PropTypes.object,
  openPopupViewStudentProfile: PropTypes.func,
  openPopupChooseStudent: PropTypes.func
};

export default EventDetail;
